import KmxSearchStroked from '@kmx/mui-icons/KmxSearchStroked';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import InputAdornment from '@mui/material/InputAdornment';
import Paper from '@mui/material/Paper';
import TextField from '@mui/material/TextField';
import type React from 'react';
import { useState } from 'react';

const SearchBar = () => {
  const [searchTerm, setSearchTerm] = useState('');

  const onChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    // TODO: On change, the responsive search function should be called (with a slight buffer).
    setSearchTerm(event.target.value);
    handleResponsiveSearch();
  };

  const handleResponsiveSearch = () => {
    // TODO: Perform a mid type result display search.
  };

  const performSearch = () => {
    if (!searchTerm) {
      window.location.href = '/cars?search=&showreservedcars=false';
    } else {
      window.location.href = `/cars?search=${encodeURIComponent(searchTerm)}`;
    }
  };

  return (
    <Paper
      elevation={2}
      sx={{
        mx: 'auto',
        maxWidth: '900px',
        borderRadius: 9999,
        width: '100%',
      }}
    >
      <TextField
        aria-label="Search all CarMax"
        onChange={onChange}
        onKeyDown={event => event.key === 'Enter' && performSearch()}
        placeholder="Search all CarMax"
        sx={{
          width: '100%',
          borderRadius: 9999,
        }}
        slotProps={{
          htmlInput: {
            sx: { ml: 3 },
          },
          input: {
            sx: {
              borderRadius: 9999,
            },
            endAdornment: (
              <InputAdornment position="end">
                <Divider
                  orientation="vertical"
                  sx={{ height: '32px', mr: 1 }}
                />
                <IconButton onClick={performSearch} aria-label="Search">
                  <KmxSearchStroked />
                </IconButton>
              </InputAdornment>
            ),
          },
        }}
      />
    </Paper>
  );
};

export default SearchBar;
